export default __webpack_public_path__ + "static/media/card-partner.057428f9.jpg";